import { render } from "./TextWithPhotoMobile.vue?vue&type=template&id=f4b6f870&scoped=true"
import script from "./TextWithPhotoMobile.vue?vue&type=script&lang=js"
export * from "./TextWithPhotoMobile.vue?vue&type=script&lang=js"

import "./TextWithPhotoMobile.vue?vue&type=style&index=0&id=f4b6f870&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b6f870"]])

export default __exports__